import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, NgModule, Output, Renderer2 } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IconDirectiveModule } from '@wipo/w-angular/directives';
import { CreateControlAccessProvider, ValueAccessor, WInputBase } from '@wipo/w-angular/shared';

@Component({
    selector: 'w-inline-filter',
    providers: [CreateControlAccessProvider(WInlineFilterComponent)],
    templateUrl: './w-inline-filter.component.html',
    host: {
      'class': 'b-inline-filter',
    },
    standalone: false
})
export class WInlineFilterComponent extends WInputBase implements ValueAccessor {
    @Output() wChange = new EventEmitter<string>();
    constructor(protected _renderer: Renderer2, protected _elementRef: ElementRef){super();
      this.placeholder = 'Search';
    }
    clear(){
      this.value = '';
      this.wChange.emit('');
    }
}

@NgModule({
    imports: [CommonModule, FormsModule, IconDirectiveModule],
    exports: [WInlineFilterComponent],
    declarations: [WInlineFilterComponent]
  })
  export class WInlineFilterModule { }
